import React, { Component, lazy } from "react";
import { Switch, Route } from "react-router-dom";

const HomeLazy = lazy(() => import("pages/post-login/home/Home.js"));

class App extends Component {
  // constructor() {
  //   super();

  //   this.state = {
  //     isLoggedIn: false
  //   };
  // }

  render() {
    return (
      <Switch>
        <Route path="/" component={() => <HomeLazy />} />
      </Switch>
    );
  }
}

export default App;
